module.exports = __webpack_public_path__ + "static/img/quanjing_00.ace1ff7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/quanjing_00.png
// module id = 4NjN
// module chunks = 1